export const QuestionType = {
  text: 'TEXT',
  range: 'RANGE',
  number: 'NUMBER',
  signature: 'SIGNATURE',
  image: 'IMAGE',
  photo: 'PHOTO',
  confirmation: 'BOOLEAN',
  selection: 'SELECTION',
  predefined: 'PREDEFINED',
  timed: 'TIMED',
  inspection_selection: 'INSPECTION_SELECTION',
  inspection_range: 'INSPECTION_RANGE',
};

export const ElementVersionEntity = {
  mainMedia: 'mainMedia',
  tool: 'tool',
  part: 'part',
  keypoint: 'keypoint',
};
